import React, { useContext, useEffect, useState, useRef } from "react";
import $ from "jquery";
import {
  displayThumbnail,
  prefetchData,
  stopPrefetchData,
} from "../../helpers/CornerstoneThumbnailService";
import { Icon, PrimaryButton, ProgressIndicator, Stack,TooltipHost  } from "@fluentui/react";
import { PauseIcon, PlaySolidIcon } from "@fluentui/react-icons-mdl2";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import {
  enableVOISync,
  loadMPR,
} from "../../helpers/CornerstoneViewportService";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost"
import * as cornerstone from "@cornerstonejs/core";
import {
  THUMBNAIL_BATCH_SIZE,
  THUMBNAIL_FETCH_SIZE,
  TOAST_TYPE,
} from "../../../../constants/Constants";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { isMobile } from "react-device-detect";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import "../../styles/styles.css";
import loaderContext from "../../../../context/loader/LoaderContext";
import { isReconstructable } from "../../helpers/MPRService";
import { useTranslation } from "react-i18next";
import toastContext from "../../../../context/toast/ToastContext";
import { WindowLevelTool } from "@cornerstonejs/tools";
import ProgressBar from "./ProgressBar";
import { isSeriesValid } from "../../helpers/ViewerHelperService";
import Spinner from "../../../../components/Spinner/Spinner";
import themeContext from "../../../../context/theme/ThemeContext";

const imageCountSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      d="M9.24809 1.81334C9.68603 1.96724 10 2.38445 10 2.875V7.875C10 9.0486 9.0486 10 7.875 10H2.875C2.38445 10 1.96724 9.68603 1.81334 9.24809L2.86198 9.24978L7.875 9.25C8.63439 9.25 9.25 8.63439 9.25 7.875V2.875L9.24801 2.84951L9.24809 1.81334ZM7.62341 0C8.24473 0 8.74841 0.50368 8.74841 1.125V7.62341C8.74841 8.24473 8.24473 8.74841 7.62341 8.74841H1.125C0.50368 8.74841 0 8.24473 0 7.62341V1.125C0 0.50368 0.50368 0 1.125 0H7.62341Z"
      fill="#747474"
    />
  </svg>
);

const Thumbnail = ({
  stack,
  index,
  originalStack,
  heatmapStack,
  outlineStack,
  isPriors,
  studyIndex,
  priors,
}) => {
  const {
    activeThumbnailIndex,
    changeActiveThumbnailIndex,
    lateralThumbnailIndex,
    activeMPRThumbnailIndex,
    setActiveMPRThumbnailIndex,
    setActiveModality,
    stackScrollActiveThumbnailIndex,
    setActiveStudyId,
    checkIfParentStudyThumbnailIsLoaded,
    setThumbnailLoadingComplete,
    loadUptoIndex,
    setLoadUptoIndex,
    checkForThumbnailReinference,
    setStackScrollActiveThumbnailIndex,
    thumbnailLoadMap, setThumbnailLoadMap
  } = useContext(ThumbnailContext);

  const {
    stackSize,
    setProgress,
    progress,
    setThumbnailLoaded,
    studyModality,
    priorStudyData,
    studyParentId,
    forceReinferenceImageIds,
    prefetchCount,
    isHPApplied,
    hpNotFound,
    hpDataList
  } = useContext(studyviewerContext);
  const {
    activeViewportIndex,
    changeViewportSeriesData,
    isMPRActive,
    setMprSeriesData,
    setIsMPRActive,
    setActiveMPRTool,
    setMprLoading,
    setDragEvent,
    setMprViewportElements,
    setIsMPRViewportActivated,
    setOriginalImageActiveState,
    originalImageActiveState,
    viewportSeriesData,
    isReferenceLinesEnabled,
    viewportRow,
    viewportColumn,
    setMPRViewportLoaderRunning,
    imageLoadedOnViewport,
    setVolumeId,
    isMPREnabled,
    setIsMPREnabled,
    hPThumbnailIds
  } = useContext(ViewportContext);
  const{getAlterColor}=useContext(themeContext)

  const { setSeriesMenu, setAlertSuccessModal, alertSuccessModal } =
    useContext(studyReportContext);

  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);

  const { t } = useTranslation();

  const [prefetchState, setPrefetchState] = useState(false);
  const [element, setElement] = useState();

  const [progressComplete, setProgressComplete] = useState({
    imageIds: stack.imageIds.slice(0),
    total: stack.imageIds.length,
    remaining: stack.imageIds.length,
    percentComplete: 0,
  });

  const [thumbnailLoading, setThumbnailLoading] = useState(true);

  const [seriesModality, setSeriesModality] = useState(stack.modality);
  useEffect(() => {
    setSeriesModality(stack.modality);
  }, []);

  const activeThumbnailIndexRef = useRef(activeThumbnailIndex);
  useEffect(() => {
    activeThumbnailIndexRef.current = activeThumbnailIndex;
    //check if entire series is downloaded for the active thumbnail
    if(index === activeThumbnailIndex) {
      if(progressComplete.percentComplete === 1) {
        setIsMPREnabled(true);
      } else {
        setIsMPREnabled(false);
      }
    }
  }, [activeThumbnailIndex]);

  let remaining = stack.imageIds.length;
  let total = stack.imageIds.length;

  let intervalId;
  let hasCompleted = false;

  const onImageLoaded = (event) => {
    const imageId = event.detail.image.image.imageId;
    if (progressComplete.imageIds.includes(imageId)) {
      if (remaining > 0) remaining -= 1;
    }

    $(function () {
      intervalId = setInterval(() => {
        if (hasCompleted) return;
        const percentComplete = isPriors && total == 1 ? 1 : (total != 1 && total == (remaining+1)) ? 0 : (total - remaining) / total;
        if (percentComplete === 1) {
          hasCompleted = true;
          clearInterval(intervalId);
          intervalId = null;
        }
        
        setProgressComplete({
          ...progressComplete,
          percentComplete: percentComplete,
          remaining: remaining
        });
        
        if(activeThumbnailIndexRef.current === index) {
          if(percentComplete === 1)
            setIsMPREnabled(true);
        }
      }, 1000);
    });
  };

  //start stop prefetch
  const togglePrefetching = async () => {
    if (seriesModality != "SR") {
      if (!prefetchState) {
        setPrefetchState(!prefetchState);
        await prefetchData(index, onImageLoaded);
      } else {
        setPrefetchState(!prefetchState);
        await stopPrefetchData(index, onImageLoaded);
      }
    }
  };

  //load lateral series in for CT,MR
  useEffect(() => {
    if (lateralThumbnailIndex === index) {
      changeViewportSeriesData(
        stack,
        stack.studyId,
        stack.studyIdDisplay,
        stack.stackId,
        seriesModality,
        1,
        stack.patientId,
        stack.patientAge,
        stack.patientSex,
        stack.patientName,
        stack.studyDescription,
        stack.studyDate,
        index,
        originalStack,
        heatmapStack,
        outlineStack,
        stack.orderId
      );
      if (stack.thumbnailImageIds.length > THUMBNAIL_FETCH_SIZE)
        togglePrefetching();
    }
  }, [lateralThumbnailIndex]);

  // useEffect(() => {
  //   const stopLoader = async (event) => {
  //     setThumbnailLoading(false);
  //   };

  //   if (element !== null) {
  //     element?.addEventListener(Enums.Events.IMAGE_RENDERED, stopLoader);

  //     return () => {
  //       element?.removeEventListener(Enums.Events.IMAGE_RENDERED, stopLoader);
  //     };
  //   }
  // }, [element]);

  //enable thumbnail
  const enableThumbnailViewport = async () => {
    const ele = $("#stack_" + index).find("#thumbnail")[0];
    if (index === 0 && hpNotFound) {
      setActiveModality(seriesModality);
      setActiveStudyId(stack.studyId);
      changeViewportSeriesData(
        stack,
        stack.studyId,
        stack.studyIdDisplay,
        stack.stackId,
        seriesModality,
        0,
        stack.patientId,
        stack.patientAge,
        stack.patientSex,
        stack.patientName,
        stack.studyDescription,
        stack.studyDate,
        0,
        originalStack,
        heatmapStack,
        outlineStack,
        stack.orderId
      );
    }
    if (seriesModality === "SR") {
      setThumbnailLoaded(true);
      setThumbnailLoading(false);
      return;
    }

    setElement(ele);
    cornerstone.eventTarget.addEventListener(
      cornerstone.EVENTS.IMAGE_CACHE_IMAGE_ADDED,
      (event) => onImageLoaded(event)
    );
    if (
      (stack.thumbnailImageIds.length <= prefetchCount || prefetchCount == -1) &&
      !isPriors
    ) {
      setTimeout(() => {
        // togglePrefetching();
      }, 1000);
    }
    await displayThumbnail(
      ele,
      index,
      stack,
      stackSize,
      isPriors,
      priorStudyData,
      studyIndex,
      setThumbnailLoaded
    );

    if (index === stackSize - 1) {
      setThumbnailLoadingComplete(true);
    }

    // if (index + 1 === loadUptoIndex) {
    //   setLoadUptoIndex((prev) => prev + THUMBNAIL_BATCH_SIZE);
    // }

    setThumbnailLoading(false);

   setThumbnailLoadMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(index, true);

      // Calculate current batch range
      const batchStart = Math.floor(index / THUMBNAIL_BATCH_SIZE) * THUMBNAIL_BATCH_SIZE;
      const batchEnd = batchStart + THUMBNAIL_BATCH_SIZE;

      // Check if the current batch is fully loaded
      const allBatchLoaded = Array.from({ length: THUMBNAIL_BATCH_SIZE }, (_, i) => 
        newMap.get(batchStart + i)
      ).every(value => value === true);

      if (allBatchLoaded) {
        const nextBatchStart = batchEnd;
        const nextBatchEnd = nextBatchStart + THUMBNAIL_BATCH_SIZE;

        for (let i = nextBatchStart; i < nextBatchEnd; i++) {
          if (!newMap.has(i)) {
            newMap.set(i, false);
          }
        }

        // Move loadUptoIndex update outside of setThumbnailLoadMap
        setLoadUptoIndex(prev => {
          const newValue = prev + THUMBNAIL_BATCH_SIZE;
          return newValue;
        });
      }

      return newMap;
    });

  };


  useEffect(()=> {
    if(index === 0){
      enableThumbnailViewport();
    }
  }, []);

  useEffect(() => {
    if (index !== 0 && hPThumbnailIds.includes(index)) {
      enableThumbnailViewport();
    }
  }, [hPThumbnailIds]);

  useEffect(() => {

    if(index === 0 || hPThumbnailIds?.includes(index)) return;

    if (
      ((index + 1 <= loadUptoIndex &&
      index + 1 > loadUptoIndex - THUMBNAIL_BATCH_SIZE) ||  isPriors) &&
      imageLoadedOnViewport
    ) {
      enableThumbnailViewport();
    }
  }, [loadUptoIndex, imageLoadedOnViewport]);

  const updateOriginalImageState = () => {
    if (originalImageActiveState[activeViewportIndex]) {
      let temp = originalImageActiveState.map((state, index) => {
        if (index === activeViewportIndex) {
          return false;
        } else return state;
      });
      setOriginalImageActiveState(temp);
    }
  };

  //change active thumbnail onclick
  const setActiveThumbnail = async () => {
    if (isMobile && thumbnailLoading && index !== 0) return;

    if (
      !isSeriesValid(
        viewportSeriesData,
        isReferenceLinesEnabled,
        stack.studyId,
        viewportRow,
        viewportColumn
      )
    ) {
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("viewer.tools.cannot-load-series");
        return newItem;
      });
      return;
    }

    setActiveModality(seriesModality);
    setActiveStudyId(stack.studyId);
    if (!prefetchState && progressComplete.percentComplete < 1) {
      togglePrefetching();
    }

    if (isMobile) {
      setSeriesMenu(false);
    }
    if (isMPRActive) {
      setIsMPRActive(false);
    }
    // if (isMPRActive) {
    //   setMPRViewportLoaderRunning(true);
    //   const isSeriesReconstructable = await isReconstructable(
    //     index,
    //     "thumbnail"
    //   );

    //   if (!isSeriesReconstructable.value) {
    //     setMPRViewportLoaderRunning(false);
    //     showToastv2(TOAST_TYPE.ERROR, t("mpr.not-reconstructable"));
    //     return;
    //   }

    //   setActiveMPRTool(WindowLevelTool.toolName);
    //   setIsMPRActive(true);
    //   setActiveMPRThumbnailIndex(index);
    //   setTimeout(async () => {
    //     await loadMPR(
    //       index,
    //       "thumbnail",
    //       stack.stackId,
    //       setMprLoading,
    //       setMprViewportElements,
    //       setIsMPRViewportActivated,
    //       setVolumeId
    //     );

    //     setMprSeriesData({
    //       study: stack.studyId,
    //       series: stack.stackId,
    //       modality: seriesModality,
    //     });
    //     // setMPRViewportLoaderRunning(false);
    //   }, 1500);

    //   enableVOISync();
    // }
    updateOriginalImageState();
    // if (!isMPRActive) {
      changeActiveThumbnailIndex(index);
      setStackScrollActiveThumbnailIndex(index);
      changeViewportSeriesData(
        stack,
        stack.studyId,
        stack.studyIdDisplay,
        stack.stackId,
        seriesModality,
        activeViewportIndex,
        stack.patientId,
        stack.patientAge,
        stack.patientSex,
        stack.patientName,
        stack.studyDescription,
        stack.studyDate,
        index,
        originalStack,
        heatmapStack,
        outlineStack,
        stack.orderId
      );
    }
  // };

  useEffect(() => {
    if (stackScrollActiveThumbnailIndex === index ) {
      setActiveThumbnail();
    }
  }, [stackScrollActiveThumbnailIndex]);

  //series drag event handler
  const handleOnDrag = (e) => {
    setDragEvent(true);
    if (progressComplete.percentComplete < 1) {
      togglePrefetching();
    }

    e.dataTransfer.setData("stack", JSON.stringify(stack));
    e.dataTransfer.setData("thumbnailIndex", index);
    e.dataTransfer.setData("study", stack.studyId);
    e.dataTransfer.setData("studyIdDisplay", stack.studyIdDisplay);
    e.dataTransfer.setData("series", stack.stackId);
    e.dataTransfer.setData("modality", seriesModality);
    e.dataTransfer.setData("patientId", stack.patientId);
    e.dataTransfer.setData("patientAge", stack.patientAge);
    e.dataTransfer.setData("patientSex", stack.patientSex);
    e.dataTransfer.setData("patientName", stack.patientName);
    e.dataTransfer.setData("studyDescription", stack.studyDescription);
    e.dataTransfer.setData("studyDate", stack.studyDate);
    e.dataTransfer.setData("originalStack", JSON.stringify(originalStack));
    e.dataTransfer.setData("heatmapStack", JSON.stringify(heatmapStack));
    e.dataTransfer.setData("outlineStack", JSON.stringify(outlineStack));
    e.dataTransfer.setData("orderId", stack.orderId);
    if (seriesModality === "SR") {
      e.dataTransfer.setData("image", stack.thumbnailImageIds[0]);
    }
    setActiveModality(seriesModality);
    setActiveStudyId(stack.studyId);
  };

  const [showTopBorder, setShowTopBorder] = useState(false);

  useEffect(() => {
    if (
      stack.studyId == studyParentId &&
      checkIfParentStudyThumbnailIsLoaded(
        studyParentId,
        viewportSeriesData,
        index
      )
    ) {
      setShowTopBorder(true);
    } else {
      setShowTopBorder(false);
    }
  }, [viewportSeriesData]);

  const [showTooltip, setShowTooltip] = useState(false);
  const descriptionRef = useRef(null);

  const handleMouseOver = ()=>{
    const el = descriptionRef.current;
    if(el && el.scrollWidth > el.clientWidth){
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  };

  return (
    <>
      <div
        id={`stack_${index}`}
        className={`thumbnail-container ${
          showTopBorder && priors ? "active-thumbnail-top-border" : ""
        }`}
        style={{ marginLeft: isMobile ? "2%" : "0" }}
      >
        <div
          className="thumbnail-box cursor-pointer"
          style={{
            borderColor: `${
              (activeMPRThumbnailIndex == index && isMPRActive) ||
              (activeThumbnailIndex == index && !isMPRActive)
                ? getAlterColor('rgb(255,255,255,1)','#0078D4')
                : "rgb(255,255,255,0.3)"
            }`,borderWidth:"3px",
            // margin: isMobile ? "" : "auto",
            height: isMobile ? "150px" : "75px",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setActiveThumbnail();
          }}
          draggable
          onDragStart={handleOnDrag}
        >
          <div
            id="thumbnail"
            style={{
              display: `${seriesModality === "SR" ? "none" : ""}`,
              pointerEvents: "none",
            }}
          ></div>
          {checkForThumbnailReinference(viewportSeriesData,forceReinferenceImageIds,index, stack) && <div className="force-retriage-progress">
          <CustomToolTipHost id="force-reinferece" content="AI Reinference is in progress...">
          <Icon style={{color: "white",marginTop:"5px"}} iconName="HourGlass" />
          </CustomToolTipHost>
          </div>}
          {seriesModality === "SR" && (
            <div className="thumbnail-sr-div">SR</div>
          )}
          {thumbnailLoading && (
            <div className="thumbnail-spinner-div">
              {" "}
              <Spinner size={10} />{" "}
            </div>
          )}
        </div>
        <TooltipHost content={stack.seriesDescription} hidden={!showTooltip}>
        <div
          ref={descriptionRef}
          className="thummbnail-description"
          // style={{ padding: isMobile ? "0px" : "0px 2px" }}
          style={{
            padding: isMobile ? "0px" : "0px 2px",
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          onMouseOver={handleMouseOver}
        >
          {stack.seriesDescription}
        </div>
        </TooltipHost>
        <div
          className="thumbnail-image-count"
          style={{
            marginLeft: isMobile ? "0%" : "3%",
          }}
        >
          <span>S : {stack.stackId}</span>
          <span>
            {imageCountSVG} : {stack.imageIds.length}
          </span>
        </div>
        {stack.modality !== "SR" && (
          <div className="thumbnail-progress-bar">
            {progressComplete.percentComplete < 1 && (
              <span
                className="cursor-pointer thumbnail-progress-icon"
                onClick={togglePrefetching}
              >
                {prefetchState ? (
                  <PauseIcon />
                ) : (
                  <PlaySolidIcon styles={{ color: "white" }} />
                )}
              </span>
            )}
            <span className="thumbnail-progress-indicator">
              <ProgressBar
                progressComplete={(
                  progressComplete.percentComplete * 100
                ).toFixed(0)}
              />
              {/* <ProgressIndicator
                barHeight={"5px"}
                styles={thumbnailProgressBarStyle}
                percentComplete={progressComplete.percentComplete}
              /> */}
            </span>
            {/* <span className="thumbnail-progress-percentage">
              {(progressComplete.percentComplete * 100).toFixed(0)}%
            </span> */}
          </div>
        )}
        {isMPRActive && activeMPRThumbnailIndex == index && (
          <div className="thumbnail-mpr-tag">{t("viewer.tools.mpr")}</div>
        )}
      </div>
    </>
  );
};

export default Thumbnail;
